import React from 'react';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import styled from 'styled-components';

const IconWrapper = styled(Icon)`
  position: absolute;
  right: -0.5rem;
  top: -0.5rem;
`;

const AccuracyBoxTooltipContent = (
  title,
  subtitle,
  text,
  planned,
  completed,
  added = 0,
  targetIconColor,
  statusIconName
) => {
  return (
    <Flex direction='column' padding='x-x-small'>
      <Flex pb='x-small' pt='small' items='center'>
        <Flex position='relative' mr='small'>
          <Icon
            data-testid='status-icon'
            name='target'
            size='large'
            color={targetIconColor}
          />
          <IconWrapper name={statusIconName} size='large' />
        </Flex>
        <Text
          color='shuttleGray'
          pl='0.3rem'
          size='normal'
          data-testid='tooltip-title'
        >
          {title}
        </Text>
      </Flex>
      <Text
        size='medium'
        pt='0.3rem'
        pb='0.9rem'
        lineHeight='1.5rem'
        data-testid='infoBox-subtitle'
      >
        {subtitle}
      </Text>
      <Text
        color='shuttleGray'
        lineHeight='1.5rem'
        pb='0.8rem'
        data-testid='tooltip-text'
      >
        {text({ planned, completed, added })}
      </Text>
    </Flex>
  );
};

export default AccuracyBoxTooltipContent;
